module.exports={
  "encoding": 'utf-8',
  "add_original_files_to_archive": true,
  "add_index_to_archive": true,
  "archive_format": "tar",
  "save_archive": false,
  "include_associated_text_files_in_proof": false,
  "include_standalone_text_files_in_proof": false,
  "generate_qrcode": false,
  "ipfs": {
    "baseUrl": "https://ipfs.io/"
  },
  "ethswarm": {
    "uploadArchive": true,
    "uploadEncrypted": false,
    "baseUrl": "https://185.25.224.202:7070/"
  }
}
